import { isBoolean } from 'lodash-es';

import { services } from 'services/base';
import {
  AboutConfig,
  AboutItem,
  AboutMainModuleItem,
  GetActiveModuleIdService,
  OnActiveModuleChangeService,
  SetActiveModuleIdService,
} from 'types';

import { getMainConfig, getModulesConfig, isAppModule } from '../../utils';

const ACTION_CHANGE_ACTIVE_MODULE = 'AppFrame:About:ChangeActiveModule';
const PREFIX = 'appFrame.about';

export const appFrameVersion: AboutMainModuleItem = {
  type: 'mainModule',
  id: process.env.REACT_APP_PACKAGE_NAME ?? 'NetLine AppFrame',
  version: process.env.REACT_APP_PACKAGE_VERSION ?? '1.x.x',
  name: process.env.REACT_APP_ABOUT_NAME ?? 'NetLine AppFrame',
};

export type AboutState = {
  activeModuleId: string;
};

const initAboutServices = () => {
  const { registerAction, clearAction, executeAction, registerService } = services;

  const state: AboutState = {
    activeModuleId: appFrameVersion.id,
  };
  const aboutMainConfig = getMainConfig('about');
  const aboutConfig: AboutConfig = (aboutMainConfig && !isBoolean(aboutMainConfig) && aboutMainConfig) || {};
  const moduleVersionsFromServerConfig = aboutConfig.moduleVersions || [];

  const applicationModuleConfigs = (getModulesConfig() || []).filter(isAppModule);
  const moduleVersionsFromModulesConfig: AboutItem[] = [];
  applicationModuleConfigs.forEach(({ moduleVersions }) => {
    if (moduleVersions && moduleVersions.length) {
      moduleVersionsFromModulesConfig.push(...moduleVersions);
    }
  });

  const defaultVersions: AboutItem[] = [
    appFrameVersion,
    ...moduleVersionsFromServerConfig,
    ...moduleVersionsFromModulesConfig,
  ];

  services.registerCollection(`${PREFIX}.modules`, defaultVersions);

  registerAction(
    ACTION_CHANGE_ACTIVE_MODULE,
    (activeModuleId: string) => {
      state.activeModuleId = activeModuleId;
    },
    { order: 0 },
  );

  registerService<GetActiveModuleIdService>(`${PREFIX}.getActiveModuleId`, () => state.activeModuleId);

  registerService<SetActiveModuleIdService>(`${PREFIX}.setActiveModuleId`, (moduleId) => {
    executeAction(ACTION_CHANGE_ACTIVE_MODULE, moduleId);
  });

  registerService<OnActiveModuleChangeService>(`${PREFIX}.onActiveModuleChange`, (callback) => {
    registerAction(ACTION_CHANGE_ACTIVE_MODULE, callback, { order: 1 });
    return () => clearAction(ACTION_CHANGE_ACTIVE_MODULE, callback);
  });
};

export default initAboutServices;
